// extracted by mini-css-extract-plugin
module.exports = {"container":"vantaggi-module--container--2I9lf","containerTesto":"vantaggi-module--containerTesto--1P5yK"};